import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DialogBase } from 't4core';
import { RentalObjectInfo, RequestDetails, ServiceRequestStatus, ServiceRequestTags, SparepartPriceModel, NoteInfo, LocationInfo } from 't4core';
import { FormControl, NgModel } from '@angular/forms';
import * as moment from 'moment';
import { UploadImagesDialog } from '../uploadImagesDialog/uploadImagesDialog';
import { ContactInfoDialog } from '../../../apps/Service/dialogs/contactInfoDialog/contactInfoDialog';
import { T4_ServiceDialog } from '../../../apps/Service/dialogs/serviceDialog/serviceDialog';
import { AddCostsDialog } from '../../../apps/TurboOrder/dialogs/AddCostsDialog/AddCostsDialog';
import { InsuranceInfoDialogComponent } from '../insurance-info-dialog/insurance-info-dialog.component';
import { InsuranceImageInfoDialogComponent } from '../insurance-image-info-dialog/insurance-image-info-dialog.component';
import * as uuid from 'uuid';
import { T4File } from '../../../../projects/t4core/src/public-api';

@Component({
    selector: 'createServiceRequestDialog',
    templateUrl: 'createServiceRequestDialog.html',
})
export class CreateServiceRequestDialog extends DialogBase implements OnInit {

    public rentalObject: RentalObjectInfo;
    public rentalLocationId: number;
    public bookingId: number | null = null;
    public issueTypeSelected: boolean = false;

    public images: string = null;
    public files: T4File[] = [];
    public noOfFiles: number = 0;
    public imageUploaded = false;
    public fileUploaded = false;
    public guid = uuid.v4();
    public selectedLanguageDamageReportTemplate: string = "sv";
    public lockConfirmed: boolean = false;

    public disableChecked: boolean = false;

    public isBackOffice: boolean = false;

    public isTrailerInspectionFlow: boolean = false;
    public rentalObjects: RentalObjectInfo[] = [];
    public servicePartners: LocationInfo[];
    public selectedServicePartnerId: number;
    
    public get isOneWay(): boolean {
        return this.rentalObject ? (this.rentalObject.Type.Id == 421 || this.rentalObject.Type.Id == 422 || this.rentalObject.Type.Id == 423 || this.rentalObject.Type.Id == 340) : false;
    }
    public selectedDamage: Array<string>;
    public damage = {
        lock: false,
        wire: false,
        tyre: false,
        supportWheel: false,
        chassi: false,
        reflex: false,
        lamp: false,
        hitch: false,
        fender: false,
        mudFlap: false,
        other: false
    }

    public actions = {
        disable: true,
        orderService: false,
        orderSparePart: false,
        incomplete: false
    }

    public settings = {
        isInsuranceCase: false
    }

    public description: string = "";
    public customerDescription: string = "";

    public errDescription: boolean = false;
    public errNoDamage: boolean = false;
    public errNoRecordNumber: boolean = false;

    public recordNumber: string;
    public issueType: string = '0';

    public damgeDate = new FormControl();
    public theftLocation: string = "0"; 

    public get newEstimatedDate(): moment.Moment {
        return this.damgeDate.value;
    }

    public contactFirstName: string
    public contactLastName: string;
    public contactEmail: string;
    public contactPhone: string;

    constructor(
        public dialogRef: MatDialogRef<CreateServiceRequestDialog>, public Dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      super("CreateServiceRequestDialog");

      if (data && data.origin === 'TrailerInspections') {
        this.isTrailerInspectionFlow = true;
        this.rentalObjects = data.rentalObjects;

        if (data.rentalLocation) {
          this.rentalLocationId = data.rentalLocation;
        }

        // pick representative object
        this.rentalObject = this.rentalObjects[0];

        this.issueTypeSelected = true;
        this.settings.isInsuranceCase = false;
      } else {

          if (data.bookingId) this.bookingId = data.bookingId;
          if (data.rentalLocation) this.rentalLocationId = data.rentalLocation;
          this.rentalObject = data.rentalObject;


          //Default 0 - Service Request
          if (data.defaultIssue) this.issueTypeSelected = true;
          if (data.preDefinedComment != "") this.description = data.preDefinedComment;

          if (!this.rentalObject) {
            this.Api.get<RentalObjectInfo>("/RentalObject/GetObjectInfo", { objectId: data.rentalObjectId }).then(x => {
              this.rentalObject = x;
              this.rentalLocationId = this.rentalObject.RentalLocation.Id;
              //this.actions.disable = (this.Settings.clientSettings.Objects.AutoDisableOnNewIssue || this.isOneWay);
              //if (this.isOneWay) this.issueTypeSelected = true;
            });
          } else {
            //if (this.isOneWay) this.issueTypeSelected = true;
          }

          this.damgeDate.setValue(moment());

      }

        
    }
  ngOnInit(): void {
    //this.actions.disable = (this.Settings.clientSettings.Objects.AutoDisableOnNewIssue || this.isOneWay);
    this.isBackOffice = this.Settings.isInAny(['BackOffice']) ? true : false;

    if (this.isTrailerInspectionFlow) {
      this.loadServicePartners();
    }

  }
  public async loadServicePartners() {
    console.log("rental objects", this.rentalObjects);
    var token = this.beginLoad('Service Partners','Loading service partners',null);

    try {
      const partnersMap = new Map<number, LocationInfo>();
      const seenLocations = new Set<number>();

      for (const r of this.rentalObjects || []) {
        const loc = r.RentalLocation;

        if (!loc || seenLocations.has(loc.Id)) continue;
        if (!loc.Latitude || !loc.Longitude) continue;

        seenLocations.add(loc.Id);

        const partners = await this.Api.get<LocationInfo[]>('/Service/GetServicePartners',{ lat: loc.Latitude, lng: loc.Longitude });

        for (const p of partners || []) {
          partnersMap.set(p.Id, p);
        }
      }

      this.servicePartners = Array.from(partnersMap.values());

    } catch (e) {
      this.servicePartners = [];
    }

    this.endLoad(token);
  }
    public async uploadImages() {
        var data = await this.Dialog.open(UploadImagesDialog, { data: { files: this.files, fileType: 'img', requestId: this.guid } }).afterClosed().toPromise();

        if (data && data.files) {
            this.files = data.files;
            if (this.files.find(x => x.Filename.startsWith('img_'))) { this.imageUploaded = true; }
            else { this.imageUploaded = false; }
            this.noOfFiles = this.files.length - 1;
        }
        else {
            this.files = await this.Api.get<any[]>("Service/GetFiles", { requestId: this.guid });
            if (this.files.find(x => x.Filename.startsWith('img_'))) { this.imageUploaded = true; }
            else { this.imageUploaded = false; }
            this.noOfFiles = this.files.length - 1;
        }
    }

    public async uploadFiles() {
        var data = await this.Dialog.open(UploadImagesDialog, { data: { files: this.files, fileType: 'doc', requestId: this.guid  } }).afterClosed().toPromise();

        if (data && data.files) {

            this.files = data.files;
            if (this.files.find(x => x.Filename.startsWith('doc_'))) { this.fileUploaded = true; }
            else { this.fileUploaded = false; }
            this.noOfFiles = this.files.length - 1;
        }
        else {
            this.files = await this.Api.get<any[]>("Service/GetFiles", { requestId: this.guid });
            console.log(this.files);
            if (this.files.find(x => x.Filename.startsWith('doc_'))) { this.fileUploaded = true; }
            else { this.fileUploaded = false; }
            this.noOfFiles = this.files.length - 1;
        }
    }

    public async save() {
  
      if (this.isTrailerInspectionFlow) {
            return await this.createInspectionRequests();
        }

        var token = this.beginLoad("Turbo.Service.CreateRequestDialog.ldrSaving", "Registering issue", null);
      var confirmWebHooks = false;
      //this.damage.other = true;

      //Error description
        this.errDescription = this.description == null || this.description.length < 5 || this.description.trim().indexOf(" ") <= 0;

        //Error no damage
        this.errNoDamage = this.settings.isInsuranceCase && +this.issueType <= 1 && !
            (this.damage.lock ||
                this.damage.wire ||
                this.damage.tyre ||
                this.damage.supportWheel ||
                this.damage.chassi ||
                this.damage.reflex ||
                this.damage.lamp ||
                this.damage.hitch ||
                this.damage.fender ||
                this.damage.mudFlap ||
                this.damage.other
            );

        //Error no police record number
        this.errNoRecordNumber = this.settings.isInsuranceCase && +this.issueType > 1 && (!this.recordNumber || this.recordNumber.length < 1);

        if (this.errDescription || this.errNoRecordNumber || this.errNoDamage) {
            this.endLoad(token);
            return;
        }

        //Open contact person form
        if (this.settings.isInsuranceCase) {
            var data = await this.Dialog.open(ContactInfoDialog, { data: { contactFirstName: this.contactFirstName, contactLastName: this.contactLastName, contactEmail: this.contactEmail, contactPhone: this.contactPhone } }).afterClosed().toPromise();

            if (data && data.contactFirstName && data.contactLastName && data.contactEmail && data.contactPhone) {
                this.contactFirstName = data.contactFirstName;
                this.contactLastName = data.contactLastName;
                this.contactEmail = data.contactEmail;
                this.contactPhone = data.contactPhone;
            }
            else {
                this.endLoad(token);
                return;
            }
        }

        //Prompt user to upload images or documents, or give info how to do it later
        if (this.settings.isInsuranceCase && +this.issueType <= 1 && (!this.imageUploaded || !this.fileUploaded)) {
          var continueAnyway = await this.Dialog.open(InsuranceImageInfoDialogComponent, { data: { regNo: this.rentalObject.Title, fileUploaded: this.fileUploaded, imageUploaded: this.imageUploaded, stolen: +this.issueType > 1 } }).afterClosed().toPromise();
            if (!continueAnyway) {
                  this.endLoad(token);
                  return;
              }
        }

        this.actions.incomplete = (this.settings.isInsuranceCase && +this.issueType <= 1 && (!this.imageUploaded || !this.fileUploaded));

        var aggregatedDescription = this.description;
        var aggregatedTags = ServiceRequestTags.None;

        if (this.customerDescription) aggregatedDescription += "\r\n\r\nCustomer description:\r\n" + this.customerDescription;

        if (this.settings.isInsuranceCase && +this.issueType <= 1) {
            if (this.damage.lock) aggregatedTags |= ServiceRequestTags.Lock;
            if (this.damage.wire) aggregatedTags |= ServiceRequestTags.Wire;
            if (this.damage.tyre) aggregatedTags |= ServiceRequestTags.Tyre;
            if (this.damage.supportWheel) aggregatedTags |= ServiceRequestTags.SupportWheel;
            if (this.damage.chassi) aggregatedTags |= ServiceRequestTags.Chassi;
            if (this.damage.reflex) aggregatedTags |= ServiceRequestTags.Reflex;
            if (this.damage.lamp) aggregatedTags |= ServiceRequestTags.Lamp;
            if (this.damage.hitch) aggregatedTags |= ServiceRequestTags.Hitch;
            if (this.damage.fender) aggregatedTags |= ServiceRequestTags.Fender;
            if (this.damage.mudFlap) aggregatedTags |= ServiceRequestTags.MudFlap;
        }

        if (this.settings.isInsuranceCase) {
            if (+this.issueType == 0) {
                aggregatedTags |= ServiceRequestTags.InsuranceDamageDuringRent;
                console.log(this.issueType);
            }
            if (+this.issueType == 1) {
                aggregatedTags |= ServiceRequestTags.InsuranceDamageAtLocation;
            }
            if (+this.issueType == 2) {
                aggregatedTags |= ServiceRequestTags.StolenDuringRent;
            }
            if (+this.issueType == 3) {
                aggregatedTags |= ServiceRequestTags.StolenFromLocation;
            }
      }

      if (this.settings.isInsuranceCase && this.issueType == '3') {
        aggregatedDescription += "\r\n\r\nTrailer lock confirmed: " + this.lockConfirmed;
      }

        var result = await this.Api.post<RequestDetails>("/Service/CreateRequest", null, {
            rentalObjectId: this.rentalObject.Id,
            description: aggregatedDescription,
            isInsurance: this.settings.isInsuranceCase,
            disable: this.isBackOffice ? this.disableChecked : this.actions.disable,
            tags: aggregatedTags,
            imageIdentifier: this.guid,
            images: null,
            incidentDate: this.damgeDate.value.toISOString(),
            ContactFirstName: this.contactFirstName,
            ContactLastName: this.contactLastName,
            ContactEmail: this.contactEmail,
            ContactPhone: this.contactPhone,
          RecordNumber: this.recordNumber
        });

        if (result) {

            var status = ServiceRequestStatus.Invalid;
            if (this.actions.orderService) status = ServiceRequestStatus.ServiceRequested;
            if (this.actions.orderSparePart) status = ServiceRequestStatus.SparePartRequested;
            if (this.actions.disable) this.rentalObject.IsEnabled = false;
          
            console.log(this.actions.incomplete);

            if (status != ServiceRequestStatus.Invalid) {
                await this.Api.post<RequestDetails>("/Service/UpdateRequest", {
                    RequestId: result.Id,
                    NewStatus: status,
                    Tags: aggregatedTags == 0 ? null : aggregatedTags,
                    IsInsurance: this.settings.isInsuranceCase,
                    ConfirmWebHooks: confirmWebHooks   
                });              
            }

            // Get customer price
          if (aggregatedTags != ServiceRequestTags.None && this.bookingId) {
                await this.Api.get<SparepartPriceModel>("/Price/GetSparepartPrice",
                    {
                        spareParts: aggregatedTags,
                        returnLocationId: this.rentalLocationId,
                        discountId: ''
                  }).then(y => {
                        this.dialogRef.close(y);
                    });
          } else {
            if (this.isBackOffice) {
              this.dialogRef.close(result)
            }
            else {
              this.dialogRef.close();
            }



            }

            this.Dialog.open(T4_ServiceDialog, { data: { requestId: result.Id } });
        }

    }

  public async createInspectionRequests() {
    if (!this.rentalObjects || this.rentalObjects.length === 0) return;

    var token = this.beginLoad('Creating service requests','Creating service requests', null);

    try {
      const results: any[] = [];
      const errors: any[] = [];

      for (const obj of this.rentalObjects) {
        try {
          const res = await this.Api.post<RequestDetails>("/Service/CreateRequest",null,
            {
              rentalObjectId: obj.Id,
              servicePartnerId: this.selectedServicePartnerId,
              description: this.description || "Besiktning",
              isInsurance: false,
              disable: true,
              tags: ServiceRequestTags.Inspection,
              imageIdentifier: this.guid,
              incidentDate: this.damgeDate?.value?.toISOString() || new Date().toISOString(),
              ContactFirstName: null,
              ContactLastName: null,
              ContactEmail: null,
              ContactPhone: null,
              RecordNumber: null
            }
          );

          if (res) results.push(res);
        } catch (e) {
          errors.push({ rentalObjectId: obj.Id, error: e });
        }
      }

      this.dialogRef.close({ results, errors });

    } finally {
      this.endLoad(token);
    }
  }
  public static async open(dialog: MatDialog, objectId: number, locationId: number, object: RentalObjectInfo = null, bookingId: number = null, defaultIssue: boolean = false, preDefinedComment: string = null): Promise<SparepartPriceModel[]> {
        var dlg = dialog.open(CreateServiceRequestDialog, {
            maxHeight: "calc(100vh - 20px)",
            maxWidth: "calc(100vw - 20px)",
            data: {
                rentalObject: object,
                rentalObjectId: objectId,
                rentalLocation: locationId,
                defaultIssue: defaultIssue,
                preDefinedComment: preDefinedComment,
            }
        });

        return await dlg.afterClosed().toPromise();
    }

    public setDamages() {
        this.damage.lock = false;
        this.damage.wire = false;
        this.damage.tyre = false;
        this.damage.supportWheel = false;
        this.damage.chassi = false;
        this.damage.reflex = false;
        this.damage.lamp = false;
        this.damage.hitch = false;
        this.damage.fender = false;
        this.damage.mudFlap = false;
        this.damage.other = false;

        for (let dam of this.selectedDamage) {
            this.damage[dam] = true;
        }
    }

    public async createNote() {
        var response = await this.UI.prompt("turbo.core.dialogs.CreateService.promptNoteHeadline", "Create note", "turbo.core.dialogs.CreateService.promptNoteQuery", "Please describe the minor damage as briefly as possible.");
        if (response) {
            await this.Api.get<NoteInfo>("RentalObject/CreateNote", { objectId: this.rentalObject.Id, note: response });
            this.dialogRef.close();
        }
    }


    public async reportToInsuranceCompany() {

        var ins = await this.Dialog.open(InsuranceInfoDialogComponent, { data: { } }).afterClosed().toPromise();

        if (ins != null) {
            this.settings.isInsuranceCase = ins;
        }
        console.log(ins);

  }

  public downloadTemplate(language: string) {
    if (language == 'sv') {
      window.open("https://thuleturbo.blob.core.windows.net/cdn/Documents/Damage_SE.pdf", '_blank').focus();
    }
    if (language == 'da') {
      window.open("https://thuleturbo.blob.core.windows.net/cdn/Documents/Damage_DK.pdf", '_blank').focus();
    }
    if (language == 'nn') {
      window.open("https://thuleturbo.blob.core.windows.net/cdn/Documents/Damage_NO.pdf", '_blank').focus();
    }
  }

  public async redirectToInsuranceHelp() {
    var URL = "https://brenderuprental.zendesk.com/hc/en-us/articles/4417829797393-Information-about-insurance";

    window.open(URL, "_blank");
  }
}
